// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fa94d527","455":"0e2c1803","938":"084396c7"}[chunkId] + ".chunk.js";
};